module.exports = __webpack_public_path__ + "a1939112de53a78c66ae0520418d41.svg";